// extracted by mini-css-extract-plugin
export default {"invoices-search":"ManageInvoices_invoices-search__S+gk1","invoices-select":"ManageInvoices_invoices-select__lnfub"};